import { defineStore } from 'pinia'
import Api from '../api/Api'

const SubscriptionTypes = {
  stripe: 'stripe',
  freetrial: 'freetrial',
  starter: 'starter',
  team: 'team',
  enterprise: 'enterprise',
};

export const useTenantStore = defineStore('tenant', {
  state: () => ({
    tenants: [],
    tenantSettings: {},
  }),
  getters: {
    getSubscriptionTypes: function() {
      return SubscriptionTypes;
    },
    getRecurringSubscriptionTypes: function() {
      return [
        SubscriptionTypes.starter,
        SubscriptionTypes.team,
        SubscriptionTypes.enterprise,
      ]
    },
    getTenants: function(state) {
      return state.tenants;
    },
    getTenantSettings: function(state) {
      return state.tenantSettings;
    },
    getTenantRetentionPeriod: function (state) {
      return state.tenantSettings?.recycle_bin_retention_period ?? 90;
    },
    getTenantLinksExpiryDays: function(state) {
      return state.tenantSettings?.links_expiry_days ?? 14;
    },
    getLinksAllowDownloading: function (state) {
      return state.tenantSettings?.links_allow_downloading ?? false;
    },
    getLinksAllowComments: function (state) {
      return state.tenantSettings?.links_allow_comments ?? false;
    },
    getLinksShowAssets: function (state) {
      return state.tenantSettings?.links_show_assets ?? false;
    },
    getLinksAllowPlayingOriginalFile: function (state) {
      return state.tenantSettings?.links_allow_playing_original_file ?? false;
    },
    getLinksAddVersions: function (state) {
      return state.tenantSettings?.links_add_versions ?? false;
    },
    getLinksShowSubtitles: function (state) {
      return state?.tenantSettings?.links_show_subtitles ?? false;
    },
    getAreYouOwner: function(state) {
      return state.tenantSettings?.areYouOwner ?? false;
    }
  },
  actions: {
    fetchAllTenants: async function() {
      try {
        const result_1 = await Api.tenant.getAllTenants();
        return result_1.data;
      } catch (error) {
        console.error("Error getting tenants.", error);
      }
    },
    updateTenant: async function(payload) {
      const result = await Api.tenant.updateTenant(payload);
      return result.data;
    },
    restoreTenant: async function(payload) {
      try {
        const result = await Api.tenant.restoreTenant(payload);
        return result.data;
      } catch (error) {
        console.error("Error restoring a tenant.", error);
      }
    },

    refreshTenantSettings: async function(accessPointId) {
      try {
        const result = await Api.tenant.refreshTenantSettings(accessPointId);
        this.tenantSettings = result.data;
        return result.data;
      } catch (error) {
        console.error("Error getting tenant settings", error);
      }
    },
    updateTenantSettings: async function({ accessPointId, settings }) {
      try {
        const result = await Api.tenant.updateTenantSettings(accessPointId, settings);
        this.tenantSettings = result.data;
      } catch (error) {
        console.error("Error updating tenant settings for tenant", error);
      }
    },
    resetBandwidth: async function(accessPointId) {
      await Api.tenant.resetBandwidth(accessPointId);
    },
    /**
     * @param {{
     *   accessPointId: string,
     *   resource: string,
     *   quantity: number,
     * }} payload
     * @returns {Promise<void>}
     */
    purchaseResources: async function(payload) {
      await Api.tenant.purchaseResource(payload);
    },
    deleteOwnTenant: async function(nodeId) {
      const result = await Api.tenant.deleteOwnTenant(nodeId);
      return result.data;
    },
    promoteOwner: async function(nodeId, userId) {
      const result = await Api.tenant.promoteOwner(nodeId, userId);
      return result.data;
    }
  },
});
